import React from 'react';
import './../Content.css';
import Banner from './Banner.js';
import RetailerSearch from './../rsearch/RetailerSearch.js';
import MediaQuery from './../media-query/MediaQuery.js';

class Home extends React.Component {
  render() {
    return(
      <main className="app-content">
        <Banner searchFunc={this.props.searchFunc}/>
        <MediaQuery size="mobile">
          <RetailerSearch searchFunc={this.props.searchFunc}/>
        </MediaQuery>
      </main>
    );
  };
}

Home.propTypes = {
  searchFunc: React.PropTypes.func.isRequired,
}

export default Home



// WEBPACK FOOTER //
// ./src/components/home/Home.js